import { Pipe, PipeTransform } from '@angular/core';
import { BuildingFilterDto } from '@artemis-software/wr-api';
import InsuranceCompanyEnum = BuildingFilterDto.InsuranceCompanyEnum;

export const insuranceCompanyTranslation: Record<InsuranceCompanyEnum, string> = {
  GRAWE: 'Grazer Wechselseitige Versicherung Aktiengesellschaft',
  WIENER_STAEDTISCHE: 'WIENER STÄDTISCHE Versicherung AG Vienna Insurance Group',
  UNIQUA:'UNIQA Österreich Versicherungen AG',
  SCHINNER:'Schinner Versicherungsmaklerkanzlei GmbH',
  EKV:'EKV GmbH',
  PMC_PAUL_MAYER_CONCEPT:'PMC Paul Mayer Concept Versicherungstreuhand und Vorsorgeberatung GmbH',
  OOE_INSURANCE:'Oberösterreichische Versicherung AG',
  HDI_INSURANCE:'HDI Versicherung AG',
  DONAU_INSURANCE:'DONAU Versicherung AG Vienna Insurance Group',
  KLV:'Kärntner Landesversicherung auf Gegenseitigkeit (iwF KLV)',
};

@Pipe({
  standalone: false,
  name: 'insuranceCompanyTranslation',
})
export class InsuranceCompanyTranslationPipe implements PipeTransform {
  transform(value?: InsuranceCompanyEnum) {
    return value ? insuranceCompanyTranslation[value] : undefined;
  }
}
